import { reviveUserInfo as reviveUserUnico } from 'common/auth/Actions.js';
import AuthService from 'common/auth/AuthService.js';
import { fetchInfo } from 'common/info/Actions.js';
import { checkUserExists, loadUserRoles } from 'keycloak/Actions.js';
import keycloakService from 'keycloak/KeycloakService.js';

import { reviveUserInfo as reviveUserInfoProtocolo } from './auth/Actions.js';
import {
  fetchConfig,
  fetchConfigIsNotLoggedWithEntidade
} from './config/Actions.js';

export const fetchInitialState = async store => {
  const logged = store.getState().auth.get('preLogged');

  let nextPathIsNumeric;
  try {
    nextPathIsNumeric = window.location.pathname.match(/\d+/)[0];
  } catch (error) {
    nextPathIsNumeric = undefined;
  }

  let config;
  if (nextPathIsNumeric && !logged) {
    config = await store.dispatch(
      fetchConfigIsNotLoggedWithEntidade(nextPathIsNumeric)
    );
  } else {
    config = await store.dispatch(fetchConfig());
  }

  let reviveFn = '';

  if (config.value.integradoUnico) {
    reviveFn = reviveUserUnico;
  } else if (config.value.isStandalone) {
    reviveFn = reviveUserInfoProtocolo;
  } else {
    const authenticated = await keycloakService.checkSSO({
      token: AuthService.getAuthorizationToken(),
      refreshToken: AuthService.getRefreshToken()
    });

    if (authenticated) {
      const { value } = await store.dispatch(checkUserExists());

      if (value) {
        await store.dispatch(loadUserRoles());
      } else {
        await store.dispatch(fetchInfo());
        return Promise.resolve(config.value);
      }
    }

    reviveFn = reviveUserInfoProtocolo;
  }

  if (logged || keycloakService.isLogged()) {
    await store.dispatch(reviveFn());
  }

  await store.dispatch(fetchInfo());

  return Promise.resolve(config.value);
};
